import React from 'react'
import { Navigate } from 'react-router-dom'
import MainLayout from '../Layout/MainLayout'



const PrivateRoutes = () =>
{


 const z = localStorage.getItem("token")

let auth = { token: !!z }
  return (
    auth.token ? <MainLayout /> : <Navigate to="/login" />
  )
}

export default PrivateRoutes
